var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM11.9736 7.08301C11.8549 6.96428 11.6682 6.98125 11.5664 7.08301L10.0059 8.64355L8.44629 7.08301C8.32757 6.96429 8.14083 6.98126 8.03906 7.08301L7.08887 8.03223C6.9702 8.15089 6.97032 8.32074 7.08887 8.43945L8.64941 10L7.08887 11.5605C6.97032 11.6793 6.9702 11.8491 7.08887 11.9678L8.03906 12.917C8.14083 13.0187 8.32757 13.0357 8.44629 12.917L10.0059 11.3564L11.5664 12.917C11.6682 13.0188 11.8549 13.0357 11.9736 12.917L12.9238 11.9678C13.0255 11.8661 13.0253 11.6624 12.9238 11.5605L11.3633 10L12.9238 8.43945C13.0253 8.3376 13.0255 8.1339 12.9238 8.03223L11.9736 7.08301Z",
    fill: "#EC6655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconR);
export default __webpack_public_path__ + "static/media/x-icon-r.cf094f660de1790aedbcb98343cf4d0e.svg";
export { ForwardRef as ReactComponent };